import React, { Component } from "react";

class ToggleComponent extends Component {
  constructor(props, context) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="btn-group btn-group-toggle" data-toggle="buttons">
        <label
          className={
            this.props.isActive === this.props.positiveValueTobeCompare
              ? "btn btn-secondary active"
              : "btn btn-secondary"
          }
        >
          <input
            type="radio"
            name={this.props.name}
            id="option1"
            autoComplete="off"
            onChange={this.props.handleChanges}
            value={this.props.positiveValueTobeCompare}
            checked={
              this.props.isActive === this.props.positiveValueTobeCompare
            }
          />
          {this.props.positiveValueTobeDisplay}
        </label>
        <label
          className={
            this.props.isActive === this.props.negativeValueTobeCompare
              ? "btn btn-secondary active"
              : "btn btn-secondary"
          }
        >
          <input
            type="radio"
            name={this.props.name}
            id="option2"
            autoComplete="off"
            onChange={this.props.handleChanges}
            value={this.props.negativeValueTobeCompare}
            checked={
              this.props.isActive === this.props.negativeValueTobeCompare
            }
          />
          {this.props.negativeValueTobeDisplay}
        </label>
      </div>
    );
  }
}

export default ToggleComponent;
